import React from "react";
import { Input, Button, Tooltip } from "antd";
import { StopOutlined, ArrowUpOutlined } from "@ant-design/icons";

const SEARCH_BAR = ({
  isFirstMessage,
  isMobile,
  newMessage,
  handleChange,
  handleSendMessage,
  skeletonLoading,
  streamActive,
  handleStreamingStop,
  isActive,
}) => (
  <div
    style={{
      position: "fixed",
      bottom: isFirstMessage ? "65%" : "5%",
      width: isMobile ? "92%" : "79%",
      left: isMobile ? "5%" : "20%",
      padding: "1% 1% 1%",
      background: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: isFirstMessage ? "translateY(50%)" : "none",
      zIndex: 100,
      overflowX: "hidden",
    }}
  >
    <Input.TextArea
      value={newMessage}
      onChange={handleChange}
      onPressEnter={(e) => {
        if (!e.shiftKey) {
          // Only trigger on Enter without Shift
          e.preventDefault();
          handleSendMessage();
        }
      }}
      placeholder="Ask me anything"
      autoSize={{
        minRows: 1.8,
        maxRows: isMobile ? 2 : 12,
      }}
      style={{
        marginRight: "10px",
        fontSize: "small",
        flex: isMobile ? 1 : "none",
        width: isMobile ? "80%" : "80%",
      }}
      disabled={skeletonLoading}
    />

    {streamActive ? (
      <Tooltip title="Stop Generating">
        <Button
          style={{
            backgroundColor: "black",
            borderColor: "black",
            color: "white",
            marginLeft: "8px",
          }}
          icon={
            <StopOutlined
              style={{
                color: "white",
                fontSize: "medium",
                fontWeight: "bolder",
              }}
            />
          }
          onClick={handleStreamingStop}
          disabled={!streamActive}
        />
      </Tooltip>
    ) : (
      <Button
        style={{
          backgroundColor: isActive ? "green" : "lightgrey",
          borderColor: isActive ? "green" : "lightgrey",
          color: "white",
        }}
        icon={
          <ArrowUpOutlined
            style={{
              color: isActive ? "white" : "grey",
              fontSize: "medium",
              fontWeight: "bolder",
            }}
          />
        }
        onClick={handleSendMessage}
        disabled={!isActive || skeletonLoading}
      />
    )}
  </div>
);

export default SEARCH_BAR;
